<template>
  <div>
    <div class="px-4">
      <v-layout>
        <v-flex sm9 xs12>
          <v-text-field
            prepend-icon="search"
            label="SEARCH"
            hide-details
            v-model="search"
            class="pr-4"
          ></v-text-field>
        </v-flex>
        <v-flex sm3 xs12>
          <v-select
            label="PROVINCE"
            v-model="province"
            :items="provinceData"
            item-text="province_name_th"
            item-value="province_name_en"
            @change="changeProvince($event)"
          ></v-select>
        </v-flex>
      </v-layout>
    </div>
    <v-data-table
      :headers="headers"
      :loading="isLoading"
      :items="filterStoreList"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-center">
          {{ props.item.store_name_th }}
          <span style="color: grey" v-if="props.item.store_name_en">{{
            `(${props.item.store_name_en})`
          }}</span>
        </td>

        <td class="text-xs-center">{{ props.item.store_service_name_th }}</td>
        <td
          class="text-xs-center"
          :style="{
            fontWeight: 'bold',
            color:
              props.item.store_use_pos == 0 &&
              props.item.store_on_hold_msg == 'hold_document'
                ? 'red'
                : props.item.store_use_pos == 0
                ? 'red'
                : props.item.store_use_pos == 1 &&
                  props.item.store_on_hold_msg == 'hold_document'
                ? 'orange'
                : props.item.store_use_pos == 1
                ? 'orange'
                : props.item.store_use_pos == 2
                ? 'orange'
                : props.item.store_use_pos == 3
                ? 'green'
                : '',
          }"
        >
          {{
            props.item.store_use_pos == 0 &&
            props.item.store_on_hold_msg == "hold_document"
              ? "Upload Document"
              : props.item.store_use_pos == 0
              ? "Waiting for Approve Contact"
              : props.item.store_use_pos == 1 &&
                props.item.store_on_hold_msg == "hold_document"
              ? "Waiting for Approve Document"
              : props.item.store_use_pos == 1
              ? "Enter Store Information"
              : props.item.store_use_pos == 2
              ? "Waiting for Store Information"
              : props.item.store_use_pos == 3
              ? "Avaliable"
              : ""
          }}
        </td>
        <td class="text-xs-center">
          <v-btn icon @click="toEditUser(props.item)"
            ><v-icon>remove_red_eye</v-icon></v-btn
          >
        </td>
        <td
          class="text-xs-center"
          v-if="
            props.item.store_use_pos == 0 &&
            props.item.store_on_hold_msg == 'hold_document'
          "
        >
          <v-tooltip top>
            <v-btn icon @click="toGenerateLink(props.item)" slot="activator">
              <v-icon small>link</v-icon>
            </v-btn>
            <span>Get Document Link</span>
          </v-tooltip>
        </td>
        <td v-else></td>
      </template>

      <template slot="no-data">
        <div v-if="filterStoreList.length == 0 && isLoading == false">
          No data available
        </div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="showFormUser" max-width="500px">
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>{{ selectStore.store_name_th }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showFormUser = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="max-height: 70vh; overflow: auto">
          <div v-for="(info, index) in userInfo" :key="index">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <span style="font-weight: bold; font-size: 16px">
                TEL :
                <span style="color: grey">{{ `0${info.user_tel}` }}</span>
              </span>
              <span style="display: flex; align-items: center">
                <v-btn @click="toSeeSession(info)" icon>
                  <v-icon color="info">login</v-icon>
                </v-btn>
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    icon
                    :disabled="!hasUsId(info) || settingDefaultPayment"
                    :loading="settingDefaultPayment"
                    @click="toSetDefaultPayment(info)"
                  >
                    <v-icon :color="info.default_payment ? 'warning' : ''">
                      {{ info.default_payment ? "star" : "star_border" }}
                    </v-icon>
                  </v-btn>
                  <span v-if="!hasUsId(info)">Missing us_id</span>
                  <span v-else-if="info.default_payment">Default payout</span>
                  <span v-else>Set as default payout</span>
                </v-tooltip>
              </span>
            </div>
            <div style="display: flex; align-items: center">
              <v-text-field label="E-mail" v-model="info.user_email">
                <template v-slot:append>
                  <v-fade-transition leave-absolute>
                    <v-progress-circular
                      v-if="info.loading"
                      size="24"
                      color="info"
                      indeterminate
                    ></v-progress-circular>
                    <v-icon v-else-if="info.edited === true" color="green"
                      >check</v-icon
                    >
                    <v-icon v-else-if="info.edited === false" color="red"
                      >close</v-icon
                    >
                  </v-fade-transition>
                </template></v-text-field
              >

              <v-btn icon @click="editUserEmail(info)" :disabled="info.loading">
                <v-icon>save</v-icon></v-btn
              >
            </div>

            <div>
              <v-btn
                :loading="resending"
                dark
                @click="resendEmail(info)"
                v-if="
                  (selectStore.store_use_pos == 0 &&
                    selectStore.store_on_hold_msg == 'hold_document') ||
                  (selectStore.store_use_pos == 1 &&
                    selectStore.store_on_hold_msg == null)
                "
                >RESEND E-MAIL</v-btn
              >
              <v-btn dark @click="toResetPassword(info)">Reset password</v-btn>

              <v-btn dark color="error" @click="toRemoveUser(info)">
                remove user
              </v-btn>
            </div>
            <v-divider class="my-2"></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showResetPassword" max-width="300px" persistent>
      <v-card>
        <v-card-title>
          <h2>RESET PASSWORD</h2>
          <v-spacer></v-spacer
          ><v-btn
            :disabled="formResetPassword.loading"
            icon
            @click="closeResetPassword()"
            ><v-icon>close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-text>
          <div>OWNER TEL {{ formResetPassword.user_tel }}</div>
          <v-text-field
            label="Password"
            v-model="formResetPassword.password"
          ></v-text-field>
          <v-text-field
            label="Confirm Password"
            v-model="formResetPassword.confirm_password"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="red"
            :disabled="formResetPassword.loading"
            @click="closeResetPassword()"
            >Cancel</v-btn
          >
          <v-btn
            flat
            color="green"
            :loading="formResetPassword.loading"
            @click="resetPassword()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="storeLinkDialog" max-width="400px">
      <v-card>
        <v-card-title class="d-flex justify-space-between pb-0"
          ><div style="font-size: 20px; font-weight: bold">LINK GENERATOR</div>
          <div class="text-xs-right">
            <v-btn icon @click="storeLinkDialog = false"
              ><v-icon>close</v-icon></v-btn
            >
          </div>
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-text-field
              id="copyInput"
              label="Store link"
              v-model="linkGenerated"
              readonly
            ></v-text-field>
            <v-btn
              flat
              style="border: 1px solid black"
              @click="copyToClipboard()"
              >copy link</v-btn
            >
          </div></v-card-text
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="sessionDialog" max-width="70vw">
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title
            >การเข้าสู่ระบบของ 0{{ sessionDetail.session_tel }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="sessionDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            hide-actions
            :headers="sessionHeaders"
            :items="sessionDetail.session_list"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.index + 1 }}</td>
              <td class="text-xs-center">
                {{ moment(props.item.create_at).format("YYYY-MM-DD HH:mm:ss") }}
              </td>
              <td>
                <v-btn
                  color="warning"
                  style="color: black"
                  :loading="isTesting"
                  @click="validateDeviceToken(props.item)"
                  >ตรวจสอบการแจ้งเตือน</v-btn
                >
                <v-btn
                  color="primary"
                  style="color: black"
                  :loading="isTesting"
                  @click="testSendOrderNoti(props.item)"
                  >ทดสอบแจ้งเตือนออเดอร์</v-btn
                >
              </td>
            </template>

            <template slot="no-data">
              <div
                v-if="loadingSession == false"
                style="display: flex; justify-content: center"
              >
                ไม่มีการเข้าสู่ระบบ
              </div>
              <div
                v-else-if="loadingSession == true"
                style="display: flex; justify-content: center"
              >
                <v-progress-circular
                  :size="30"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                {{ "Loading data ..." }}
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card></v-dialog
    >
    <v-snackbar v-model="snackBar.visibleAlert" :timeout="5000">
      <div>
        <v-icon :color="snackBar.icon == 'check' ? 'green' : 'red'">{{
          snackBar.icon
        }}</v-icon
        >{{ snackBar.message }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import CryptoJS from "crypto-js";
export default {
  props: ["itemList"],
  data: () => ({
    isRemoving: false,
    isTesting: false,
    sessionDetail: {
      session_list: [],
      session_tel: "",
    },
    loadingSession: false,
    sessionHeaders: [
      {
        text: "#",
        align: "center",
        value: "",
        sortable: false,
      },
      {
        text: "เข้าสู่ระบบเมื่อ",
        align: "center",
        value: "",
        sortable: false,
      },
      {
        text: "",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
    sessionDialog: false,
    settingDefaultPayment: false,
    resending: false,
    search: "",
    isLoading: false,
    province: null,
    linkGenerated: null,
    snackBar: { visibleAlert: false, message: "", icon: "" },
    formResetPassword: {
      user_id: null,
      user_tel: null,
      password: "",
      confirm_password: "",
      loading: false,
    },
    showFormUser: false,
    showResetPassword: false,
    storeLinkDialog: false,
    disable_popular: false,
    userInfo: [],
    selectStore: {},
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "#",
        align: "center",
        sortable: false,
      },
      {
        text: "STORE NAME",
        align: "center",
        value: "store_province_name",
        sortable: false,
      },
      {
        text: "SERVICE NAME",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "STATUS",
        align: "center",
        value: "store_address_th",
        sortable: false,
      },
      {
        text: "OWNER/RESEND E-MAIL",
        align: "center",
        value: "store_address_th",
        sortable: false,
      },
      {
        text: "LINK FOR UPLOAD DOCUMENT",
        align: "center",
        value: "store_address_en",
        sortable: false,
      },
    ],
  }),
  components: {},
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    filterStoreList() {
      return this.itemList.filter(
        (val) =>
          !this.search ||
          (val.store_name_th != null &&
            val.store_name_th.toLowerCase() &&
            val.store_name_th
              .toLowerCase()
              .includes(this.search.toLowerCase())) ||
          (val.store_name_en != null &&
            val.store_name_en.toLowerCase() &&
            val.store_name_en.toLowerCase().includes(this.search.toLowerCase()))
      );
    },
    pages() {
      if (this.length != 0) {
        this.pagination.totalItems = this.itemList.length;
      }
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {},
  async created() {
    if (this.provinceData.length > 0) {
      this.province = this.provinceData[0].province_name_en;
      this.isLoading = true;
      await this.fetchData({ province: this.province });
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions({
      getUserInfoByStore: "fetchStoreApproveBack/getUserInfoByStore",
      editEmailByUser: "fetchStoreApproveBack/editEmailByUser",
      resetUserPassword: "fetchStoreApproveBack/resetUserPassword",
      fetchData: "fetchStoreApproveBack/getStoreRegistration",
      resendEmailByUser: "fetchStoreApproveBack/resendEmail",
      fetchSessionByUserMerchantTel:
        "fetchUserBack/fetchSessionByUserMerchantTel",
      validateMerchantDeviceToken: "fetchUserBack/validateMerchantDeviceToken",
      testMerchantOrderNotification:
        "fetchUserBack/testMerchantOrderNotification",
      removeUserFromMerchant: "fetchStoreApproveBack/removeUserFromMerchant",
      setStoreDefaultPayment: "fetchStoreApproveBack/setStoreDefaultPayment",
    }),
    moment,
    getUsId(info) {
      const raw = info && info.user_store_id;
      const parsed = Number(raw);
      return Number.isFinite(parsed) ? parsed : null;
    },
    hasUsId(info) {
      return this.getUsId(info) !== null;
    },
    async toSetDefaultPayment(info) {
      const us_id = this.getUsId(info);
      if (us_id === null) return;
      if (info.default_payment) return;

      this.settingDefaultPayment = true;
      const result = await this.setStoreDefaultPayment({ us_id });
      this.settingDefaultPayment = false;

      if (result === false) {
        this.snackBar.message = "ตั้งค่า default payout ไม่สำเร็จ";
        this.snackBar.icon = "close";
        this.snackBar.visibleAlert = true;
        return;
      }

      const rows = result && result.rows ? result.rows : null;
      if (Array.isArray(rows)) {
        // Map returned default_payment flags back to current dialog users by us_id
        const byUsId = {};
        for (const r of rows) {
          if (typeof r.us_id === "number") byUsId[r.us_id] = r;
        }
        this.userInfo = this.userInfo.map((u) => {
          const uUsId = this.getUsId(u);
          if (uUsId === null) return u;
          const mapped = byUsId[uUsId];
          if (!mapped) return { ...u, default_payment: null };
          return { ...u, default_payment: !!mapped.default_payment };
        });
      } else {
        // Fallback: enforce single default locally
        this.userInfo = this.userInfo.map((u) => {
          const uUsId = this.getUsId(u);
          if (uUsId === null) return u;
          return { ...u, default_payment: uUsId === us_id };
        });
      }

      this.snackBar.message = "ตั้งค่า default payout สำเร็จ";
      this.snackBar.icon = "check";
      this.snackBar.visibleAlert = true;
    },
    async validateDeviceToken(sessionInfo) {
      this.isTesting = true;
      await this.validateMerchantDeviceToken(sessionInfo.token_notification);
      this.isTesting = false;
    },
    async testSendOrderNoti(sessionInfo) {
      this.isTesting = true;
      await this.testMerchantOrderNotification(sessionInfo.token_notification);
      this.isTesting = false;
    },
    async toSeeSession(userInfo) {
      this.sessionDialog = true;
      this.resetSessionDetail();
      this.loadingSession = true;
      this.sessionDetail.session_tel = userInfo.user_tel;
      this.sessionDetail.session_list =
        await this.fetchSessionByUserMerchantTel(userInfo.user_tel);
      this.loadingSession = false;
    },
    resetSessionDetail() {
      this.sessionDetail = {
        session_list: [],
        session_tel: "",
      };
    },
    async changeProvince(province) {
      this.isLoading = true;
      await this.fetchData({ province });
      this.isLoading = false;
    },
    copyToClipboard() {
      var copyText = document.getElementById("copyInput");

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */

      /* Copy the text inside the text field */
      document.execCommand("copy");

      /* Alert the copied text */
      alert("Copied link");
    },
    toGenerateLink(info) {
      console.log(info);
      let store_province_name = info.store_province_name || "";
      let province = store_province_name.replace(" ", "").toLowerCase();
      let encrypted = CryptoJS.AES.encrypt(
        JSON.stringify({
          province_id: info.store_province_id,
          store_id: info.store_id,
          province,
        }),
        "s9d333dkj1594ro"
      )
        .toString()
        .replace(/\+/g, "p1L2u3S")
        .replace(/\//g, "s1L2a3S4h")
        .replace(/=/g, "e1Q2u3A4l");
      this.linkGenerated =
        `${process.env.VUE_APP_BACKOFFICE_URL}/document?cer=` + encrypted;

      this.storeLinkDialog = true;
    },
    async resetPassword() {
      if (
        this.formResetPassword.password ==
        this.formResetPassword.confirm_password
      ) {
        let form = {
          user_id: this.formResetPassword.user_id,
          user_password: this.formResetPassword.confirm_password,
        };
        this.formResetPassword.loading = true;
        let result = await this.resetUserPassword(form);
        if (result === true) {
          this.snackBar.message = "เปลี่ยนรหัสผ่านสำเร็จ";
          this.snackBar.icon = "check";
          this.snackBar.visibleAlert = true;
          this.showResetPassword = false;
        } else {
          this.snackBar.message = "เปลี่ยนรหัสผ่านไม่สำเร็จ";
          this.snackBar.icon = "close";
          this.snackBar.visibleAlert = true;
        }
        this.formResetPassword.loading = false;
      }
    },
    closeResetPassword() {
      this.showResetPassword = false;
    },
    async resendEmail(info) {
      this.resending = true;
      let store_province_name = this.selectStore.store_province_name || "";
      let province = store_province_name.replace(" ", "").toLowerCase();
      let encrypted = CryptoJS.AES.encrypt(
        JSON.stringify({
          province_id: this.selectStore.store_province_id,
          store_id: this.selectStore.store_id,
          province,
        }),
        "s9d333dkj1594ro"
      )
        .toString()
        .replace(/\+/g, "p1L2u3S")
        .replace(/\//g, "s1L2a3S4h")
        .replace(/=/g, "e1Q2u3A4l");
      let linkGenerated =
        `${process.env.VUE_APP_BACKOFFICE_URL}/document?cer=` + encrypted;
      let payload = {
        user_id: info.user_id,
        store_id: this.selectStore.store_id,
        url_hash: linkGenerated,
        province,
        store_use_pos: this.selectStore.store_use_pos,
        store_on_hold_msg: this.selectStore.store_on_hold_msg,
      };
      let result = await this.resendEmailByUser(payload);
      if (result === true) {
        this.snackBar.message = "ส่งอีเมลสำเร็จ";
        this.snackBar.icon = "check";
        this.snackBar.visibleAlert = true;
      } else {
        this.snackBar.message = "ส่งอีเมลไม่สำเร็จ";
        this.snackBar.icon = "close";
        this.snackBar.visibleAlert = true;
      }
      this.resending = false;
    },
    toResetPassword(info) {
      this.showResetPassword = true;
      this.formResetPassword = {
        user_id: info.user_id,
        user_tel: `0${info.user_tel}`,
        password: "",
        confirm_password: "",
      };
    },
    async toRemoveUser(info) {
      let isConfirm = confirm("คุณต้องการลบผู้ใช้คนนี้หรือไม่");
      if (isConfirm == false) return;
      let store_province_name = this.selectStore.store_province_name || "";
      let province = store_province_name.replace(" ", "").toLowerCase();
      let config = { province, storeId: this.selectStore.store_id };
      let payload = {
        user_id: info.user_id,
      };
      this.isRemoving = true;
      let result = await this.removeUserFromMerchant({ config, form: payload });
      this.isRemoving = false;
      if (result == false) return;
      this.showFormUser = false;
    },
    async toEditUser(info) {
      this.userInfo = [];
      this.selectStore = info;
      this.showFormUser = true;
      let store_province_name = info.store_province_name || "";
      let province = store_province_name.replace(" ", "").toLowerCase();
      let userList = await this.getUserInfoByStore({
        province,
        store_id: info.store_id,
      });

      for (let val of userList) {
        val.loading = false;
        val.edited = 3;
      }
      this.userInfo = userList;
    },
    async editUserEmail(info) {
      info.loading = true;
      info.edited = await this.editEmailByUser({
        user_id: info.user_id,
        user_email: info.user_email,
      });
      info.loading = false;
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}
.view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
